import { Text, Alert } from '@mantine/core';
import { AlertTriangle } from 'react-feather';

export interface DeclineConfirmationCardProps {
  perspective?: 'coach' | 'cm';
}

export function DeclineConfirmationCard({ perspective = 'coach' }: DeclineConfirmationCardProps) {
  const isCm = perspective === 'cm';

  return (
    <Alert
      icon={<AlertTriangle size={20} />}
      title={isCm ? 'Coach is not available' : "You've indicated you're not available"}
      color="red"
      variant="light"
      radius="md"
    >
      <Text size="sm">
        {isCm
          ? 'The coach will be marked as not available for this opportunity.'
          : "That's okay! We'll note that you're passing on this opportunity. If your situation changes, please reach out to us directly."}
      </Text>
    </Alert>
  );
}
